import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { MultiSelect } from 'react-multi-select-component'
import { bulkActions, valueRenderer, CustomItemRenderer } from '../utils'

export const TableHeader = ({
  rowSelection,
  data,
  selectedAction,
  extendFormData,
  globalFilter,
  tenantRoles,
  selectedRoles,
  showExpiring,
  actions: {
    deselectAllUsers,
    setSelectedAction,
    updateInputState,
    bulkApplyAction,
    setSelectedRoles,
    setGlobalFilter,
    setShowExpiring,
  },
}) => {
  const selectedUsers = Object.keys(rowSelection).map((index) => data[index])
  const rolesObject = {}
  const roles = tenantRoles.map(({ name, description }) => {
    rolesObject[name] = description
    return {
      label: description,
      value: name,
    }
  })
  const checkApplyButtonDisabled = () => {
    if (!selectedUsers.length) {
      return true
    }
    if (selectedAction === 'extend') {
      return !extendFormData.tenantUserRoleExpiryDate
    }
    return false
  }
  return (
    <div className="tenant-members__header">
      <div className="tenant-members__header-left">
        <div className="tenant-members__header-column">
          <div className="tenant-members__user-info">
            ({selectedUsers.length}) User selected
          </div>

          <div className="wb-margin-top-xs">
            {selectedUsers.length ? (
              <button
                className="wb-button wb-button--tertiary wb-button--small"
                onClick={deselectAllUsers}
              >
                <wb-icon
                  class="wb-button__icon"
                  aria-hidden="true"
                  flip-rtl
                  name="bds/close/24"
                ></wb-icon>
                Deselect All
              </button>
            ) : null}
          </div>
        </div>
        <div className="wb-margin-start-xs">
          <div>
            <div className="tenant-members__header__bulk-actions">
              <div>
                <wb-select-control>
                  <wb-select>
                    <label htmlFor="bulkActionsId">Bulk Actions</label>
                    <select
                      value={selectedAction}
                      id="bulkActionsId"
                      disabled={!Boolean(selectedUsers.length)}
                      onChange={(e) => setSelectedAction(e.target.value)}
                    >
                      <option value="">Please choose an Action</option>
                      {bulkActions.map(({ value, label }) => (
                        <option value={value} key={value}>
                          {label}
                        </option>
                      ))}
                    </select>
                  </wb-select>
                </wb-select-control>
              </div>
              {selectedUsers.length && selectedAction === 'extend' ? (
                <div className="wb-margin-start-xs">
                  <wb-datepicker-control>
                    <wb-input-control>
                      <wb-input>
                        <label htmlFor="roleExpiryDate">Choose date</label>
                        <input
                          type="date"
                          id="roleExpiryDate"
                          value={extendFormData.tenantUserRoleExpiryDate}
                          onChange={(e) =>
                            updateInputState(
                              'tenantUserRoleExpiryDate',
                              e.target.value,
                            )
                          }
                          min={moment().format('YYYY-MM-DD')}
                          max={moment().add(90, 'days').format('YYYY-MM-DD')}
                        />
                      </wb-input>
                    </wb-input-control>
                  </wb-datepicker-control>
                </div>
              ) : null}
              {selectedUsers.length && selectedAction ? (
                <div className="wb-margin-start-xs">
                  <button
                    type="button"
                    aria-label="Button"
                    disabled={checkApplyButtonDisabled()}
                    onClick={bulkApplyAction}
                    className="wb-button wb-button--primary wb-button--small wb-margin-start-xs"
                  >
                    Apply
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className="tenant-members__header-right wb-padding-end-xxs">
        <div>
          <wb-input-control-new>
            <label htmlFor="membersTableGlobalFilter">Search Members</label>
            <input
              placeholder="Please enter search word"
              required
              id="membersTableGlobalFilter"
              value={globalFilter ?? ''}
              className="tenant-logs__filter-col__search-input"
              onChange={(e) => setGlobalFilter(e.target.value)}
            />
            <wb-input-control-new-action>
              <button
                className="wb-round-button wb-round-button--small"
                type="button"
              >
                <wb-icon
                  className="wb-round-button__icon"
                  name="bds/search/16"
                />
              </button>
            </wb-input-control-new-action>
          </wb-input-control-new>
        </div>
        <div className="wb-margin-top-xs">
          <wb-select-control>
            <MultiSelect
              hasSelectAll={true}
              disableSearch={true}
              options={roles}
              ItemRenderer={CustomItemRenderer}
              value={selectedRoles}
              valueRenderer={(selected) =>
                selected.length > 0
                  ? valueRenderer(selected, 20)
                  : 'Filter by Roles'
              }
              onChange={(newRoles) => setSelectedRoles(newRoles)}
              labelledBy="Roles"
              overrideStrings={{ selectSomeItems: 'Filter by Roles' }}
            />
          </wb-select-control>
        </div>
        <div className="wb-margin-vertical-xs">
          <wb-toggle-control class="wb-margin-bottom-xs">
            <label htmlFor="showOnlyExpiringMembersId">
              <input
                name="data-saver"
                type="checkbox"
                id="showOnlyExpiringMembersId"
                onChange={() => setShowExpiring(!showExpiring)}
                checked={showExpiring ? 'checked' : ''}
              />
              Show Only Expiring Members
            </label>
          </wb-toggle-control>
        </div>
      </div>
    </div>
  )
}

TableHeader.propTypes = {
  rowSelection: PropTypes.object,
  data: PropTypes.array,
  selectedAction: PropTypes.string,
  extendFormData: PropTypes.shape({
    tenantUserRoleExpiryDate: PropTypes.string,
  }),
  globalFilter: PropTypes.string,
  tenantRoles: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string, description: PropTypes.string }),
  ),
  selectedRoles: PropTypes.array,
  showExpiring: PropTypes.bool,
  actions: PropTypes.shape({
    deselectAllUsers: PropTypes.func,
    setSelectedAction: PropTypes.func,
    updateInputState: PropTypes.func,
    bulkApplyAction: PropTypes.func,
    setSelectedRoles: PropTypes.func,
    setGlobalFilter: PropTypes.func,
    setShowExpiring: PropTypes.func,
  }),
}
